import { TextField } from "@mui/material";

import { useClientDetails } from "../../context/clientDetailsContext";

const DataFields = () => {
  const {
    client: { details },
  } = useClientDetails();

  const mainUser = details?.mainUser;

  const fields = [
    {
      value: mainUser?.firstName,
      id: "owner-first-name",
      label: "First Name",
    },
    {
      value: mainUser?.lastName,
      id: "owner-last-name",
      label: "Last Name",
    },
    {
      value: mainUser?.email,
      id: "owner-email",
      label: "Email Address",
    },
  ];

  return (
    <>
      {fields.map((field) => (
        <TextField
          key={field.id}
          value={field.value}
          id={field.id}
          label={field.label}
          sx={{ paddingBottom: 2 }}
          size="small"
          disabled={true}
        />
      ))}
    </>
  );
};

export default DataFields;
